import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { gql, useQuery } from '@apollo/client';
import clientGraphql from '../../../common/apollo-graphql';
import AuthContext from '../../auth/context/AuthContext';
import ReferralBarChart from './ReferralBarChart';

const REFERRAL_LIST_BY_USER = gql`
  query ReferralListByUser($startDate: String!, $endDate: String!, $type: String) { 
    referral_list_by_user(start_date: $startDate, end_date: $endDate, type: $type) {
      name
      referrals
    }
  }
`;

export default function ReferralListByUser({ startDate, endDate, type }) {
  const currentUser = useContext(AuthContext);
  
  let color, label;

  switch (type) {
    case 'sent':
      color = '#1abc9c';
      label = 'Sent';
      break;
    case 'accepted':
      color = '#3498db';
      label = 'Accepted';
      break;
    case 'declined':
      color = '#e74c3c';
      label = 'Declined';
      break;
    default:
      color = '#95a5a6'; // fallback gray
      label = '';
  }

  const { data } = useQuery(REFERRAL_LIST_BY_USER, {
    client: clientGraphql,
    variables: {
      type,
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    skip: !currentUser,
  });

  const referrals = [...(data?.referral_list_by_user || [])].sort((a, b) => b.referrals - a.referrals);

  const totalReferrals = referrals.reduce((sum, r) => sum + r.referrals, 0);

  return (
    <Box sx={{ textAlign: 'center' }}>
      <Typography variant="h4" gutterBottom>
        Total Referrals {label} by Users <br />
        {startDate.format('MMMM YYYY')} - {endDate.format('MMMM YYYY')}
      </Typography>

      <ReferralBarChart
        referrals={referrals}
        color={color}
        totalLabel={`Referrals ${label} (${totalReferrals})`}
        show={referrals.length > 0}
      />
    </Box>
  );
}
